import React, { useState } from "react";
import { Modal, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FileOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
function Recommendation({ id, content, attachments, sendRecoCb }) {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    function onSend() {
        setIsModalOpen(false);
        sendRecoCb(id);
    }
    return (
        <div className="opt-app__recomendation-box">
            <div className="opt-app__recomendation-actions">
                <span
                    className="opt-app__recomendation-button"
                    onClick={() => setIsModalOpen(true)}
                >
                    <FontAwesomeIcon className="opt-app__expand-icon" icon={faPlus} />
                </span>
            </div>
            <div className="opt-app__recomendation-content">
                <p className="opt-app__text"> {content} </p>
            </div>
            <div className="opt-app__recomendation-send">
                {attachments.length > 0 && (
                    <p className="opt-app__recomendation-files">
                        {" "}
                        <FileOutlined /> {attachments.length} {t("file")}
                        {attachments.length > 1 && "s"} {t("attached")}
                    </p>
                )}
                <Button type="link" onClick={() => sendRecoCb(id)}>
                    {t("send")}
                </Button>
            </div>
            <Modal
                title={t("answer")}
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={[
                    <Button key="back" onClick={() => setIsModalOpen(false)}>
                        {t("close")}
                    </Button>,
                    <Button key="submit" type="primary" onClick={onSend}>
                        {t("send")} <ArrowRightOutlined />
                    </Button>,
                ]}
            >
                <p>{content}</p>
                <ul>
                    {attachments &&
                        attachments.map((file, index) => (
                            <li>
                                {" "}
                                <a href={file.link} target="_blank" rel="noreferrer">
                                    {t("attached")} {index + 1}
                                </a>{" "}
                            </li>
                        ))}
                </ul>
            </Modal>
        </div>
    );
}
export default Recommendation;
